import { useState } from "react";
import { Button, Card, CardBody, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";

 
import { useAuth } from "../../../../context/AuthContext";
import { login, register } from "../../../../common/auth/service/authApi";
import { toast } from "react-toastify"; 
import "./Whatnext.css";

 

const Whatnext = () => {
  const navigate = useNavigate();
 
  const isLoggedIn = !!localStorage.getItem("token");

  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const [loginModal, setLoginModal] = useState(false);

  const { login: saveLogin, } = useAuth();

  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });

  };

  const handleSubmit = async (e: React.FormEvent) => {

    e.preventDefault();

    if (!formData.email.trim()) {

      toast.error("Email is required");

      return;
    }

    if (!formData.password.trim()) {

      toast.error("Password is required");

      return;
    }

    try {

      setLoading(true);

      const response =
        await login(formData);

      saveLogin(

        response.token,

        response.userID,

        response.email,

        response.role

      );

      toast.success("Login Successful");


      if (response.role === "Admin" || response.role === "SuperAdmin") {
        navigate("/admin")
      }
      else if (response.role === "Coordinator") {
        navigate("/coordinator")
      }
      else {
        navigate("/");
        console.log("Role: ", response.role)
      }


    }
    catch (error: any) {

      toast.error(
        error?.response?.data?.message ||
        "Invalid email or password"
      );

    }
    finally {

      setLoading(false);

    }

  };


  const [regformData, setregFormData] = useState({

    name: "",

    email: "",

    phoneNumber: "",

    gender: "Male",

    password: "",

    confirmPassword: ""

  });

  const ReghandleChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {

    setregFormData({

      ...regformData,

      [e.target.name]:
        e.target.value

    });

  };

  const reghandleSubmit = async (
    e: React.FormEvent
  ) => {

    e.preventDefault();

    if (!regformData.name.trim())
      return toast.error("Name is required");

    if (!regformData.email.trim())
      return toast.error("Email is required");

    if (!regformData.phoneNumber.trim())
      return toast.error("Phone Number is required");

    if (!regformData.password)
      return toast.error("Password is required");

    if (
      regformData.password !==
      regformData.confirmPassword
    )
      return toast.error("Passwords do not match");

    try {

      setLoading(true);

      const result = await register({

        name: regformData.name,

        email: regformData.email,

        password: regformData.password,

        gender: "Male",

        phoneNumber: regformData.phoneNumber,

        role: 4

      });

      sessionStorage.setItem(
        "registerUserId",
        result.userId
      );

      sessionStorage.setItem(
        "registerEmail",
        regformData.email
      );

      sessionStorage.setItem(
        "registerPhone",
        regformData.phoneNumber
      );

      toast.success(result.message);

      navigate("/verify-account");

    }
    catch (error: any) {

      toast.error(
        error?.response?.data?.message ??
        "Registration failed"
      );

    }
    finally {

      setLoading(false);

    }

  };

  const handleJoinGroup = () => {
  if (!isLoggedIn) {
    setLoginModal(true); // Show Login Required modal
    return;
  }
};




  

 return (
  <div className="whatnext-page">

    <Card className="whatnext-card">

      <CardBody className="whatnext-card-body">

        <div className="whatnext-title">

          <h2>
            💰 Start Saving with{" "}
            <span>PriceWorth</span>
          </h2>

          <p>
            Join this group and start your learning journey.
          </p>

        </div>

        <div className="join-button-wrapper">

          <Button
            color="primary"
            className="join-group-btn"
            onClick={handleJoinGroup}
          >
            Join this Group
          </Button>

        </div>

      </CardBody>

    </Card>


    {/* ================= LOGIN REQUIRED MODAL ================= */}

    <Modal
      isOpen={loginModal}
      toggle={() => setLoginModal(false)}
      centered
      className="responsive-modal"
    >

      <ModalHeader toggle={() => setLoginModal(false)}>
        Login Required
      </ModalHeader>

      <ModalBody className="text-center login-required-body">

        <div className="login-lock-icon">
          🔒
        </div>

        <h5>Please Login</h5>

        <p>
          You need to login before accessing this feature.
        </p>

      </ModalBody>

      <ModalFooter className="responsive-modal-footer">

        <Button
          color="secondary"
          onClick={() => setLoginModal(false)}
        >
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={() => {
            setLoginModal(false);
            setShowLoginModal(true);
          }}
        >
          Login
        </Button>

      </ModalFooter>

    </Modal>


    {/* ================= REGISTER MODAL ================= */}

    <Modal
      isOpen={showRegisterModal}
      toggle={() => setShowRegisterModal(false)}
      centered
      size="lg"
      className="responsive-modal"
    >

      <ModalHeader toggle={() => setShowRegisterModal(false)}>
        Create Account
      </ModalHeader>

      <ModalBody className="responsive-modal-body">

        <Card className="register-card">

          <CardBody className="register-card-body">

            <div className="text-center register-header">

              <img
                src={`${process.env.PUBLIC_URL}/assets/PriceWorth_Logo.WebP`}
                alt="logo"
                className="brand-circle"
              />

              <h2 className="price-logo">
                Price<span>Worth</span>
                <sup>™</sup>
              </h2>

              <p className="register-subtitle">
                Create your account and start your journey.
              </p>

            </div>


            <form onSubmit={reghandleSubmit}>

              <FormGroup floating>

                <Input
                  name="name"
                  value={regformData.name}
                  onChange={ReghandleChange}
                  placeholder=""
                />

                <Label>Name</Label>

              </FormGroup>


              <FormGroup floating>

                <Input
                  type="email"
                  name="email"
                  value={regformData.email}
                  onChange={ReghandleChange}
                  placeholder=""
                />

                <Label>Email</Label>

              </FormGroup>


              <FormGroup floating>

                <Input
                  name="phoneNumber"
                  value={regformData.phoneNumber}
                  onChange={ReghandleChange}
                  placeholder=""
                />

                <Label>Phone Number</Label>

              </FormGroup>


              <FormGroup floating>

                <Input
                  type="password"
                  name="password"
                  value={regformData.password}
                  onChange={ReghandleChange}
                  placeholder=""
                />

                <Label>Password</Label>

              </FormGroup>


              <FormGroup floating>

                <Input
                  type="password"
                  name="confirmPassword"
                  value={regformData.confirmPassword}
                  onChange={ReghandleChange}
                  placeholder=""
                />

                <Label>Confirm Password</Label>

              </FormGroup>


              <Button
                color="primary"
                className="register-btn w-100 mt-3"
                disabled={loading}
              >

                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Creating Account...
                  </>
                ) : (
                  "Create Account"
                )}

              </Button>

            </form>


            <div className="text-center mt-4">

              Don't have an account?

              <Link
                to="/login"
                className="ms-2"
              >
                Login
              </Link>

            </div>

          </CardBody>

        </Card>

      </ModalBody>

    </Modal>


    {/* ================= LOGIN MODAL ================= */}

    <Modal
      isOpen={showLoginModal}
      toggle={() => setShowLoginModal(false)}
      centered
      className="responsive-modal"
    >

      


      <ModalBody className="responsive-modal-body">

        <Card className="login-card border-0">

          <CardBody className="login-card-body">

            <div className="text-center login-header">

              <img
                className="brand-circle"
                src={`${process.env.PUBLIC_URL}/assets/PriceWorth_Logo.WebP`}
                alt="PriceWorth Logo"
              />

              <h2 className="price-logo">
                Price<span>Worth</span>
                <sup>™</sup>
              </h2>

              <p className="welcome-text">
                Welcome back! Please login to continue.
              </p>

            </div>


            <form onSubmit={handleSubmit}>

              <FormGroup floating>

                <Input
                  type="email"
                  name="email"
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={handleChange}
                />

                <Label>Email</Label>

              </FormGroup>


              <FormGroup floating className="mt-3">

                <Input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter Password"
                  value={formData.password}
                  onChange={handleChange}
                />

                <Label>Password</Label>

              </FormGroup>


   <div className="login-options">

  <FormGroup check>

   <Input
  type="checkbox"
  style={{
    width: "18px",
    height: "18px",
    cursor: "pointer",
  }}
  onChange={() =>
    setShowPassword(!showPassword)
  }
/>

    <Label check >
      Show Password
    </Label>

  </FormGroup>

  <Link to="/forgot-password">
    Forgot Password?
  </Link>

</div>

<Button
  color="primary"
  className="w-100 login-btn mt-3"
  disabled={loading}
>
  {loading ? (
    <Spinner size="sm" />
  ) : (
    "Login"
  )}
</Button>

            </form>


            <div className="text-center mt-4">

              Don't have an account?

              <Link
                to="/register"
                className="ms-2"
              >
                Create Free Account
              </Link>

            </div>

          </CardBody>

        </Card>

      </ModalBody>

    </Modal>

  </div>
);
};

export default Whatnext;